import { render } from "./limitedRecruitment.vue?vue&type=template&id=39d65322&scoped=true&ts=true"
import script from "./limitedRecruitment.vue?vue&type=script&lang=ts"
export * from "./limitedRecruitment.vue?vue&type=script&lang=ts"

import "./limitedRecruitment.vue?vue&type=style&index=0&id=39d65322&scoped=true&lang=scss"

import exportComponent from "/var/jenkins_home/workspace/hw-employment-front-end-project/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39d65322"]])

export default __exports__